import { createContext, useState } from "react";

import { IGroup } from "pages/[tenant]/g/@types";

import { IPagePresentatinContextProps } from "../types";

export const PagePresentatinContext = createContext(
  {} as IPagePresentatinContextProps,
);

export const PagePresentationProvider = ({ children }) => {
  const [aditionalGroupNexusList, setAditionalGroupsNexusList] = useState<
    IGroup[]
  >([]);

  return (
    <PagePresentatinContext.Provider
      value={{ aditionalGroupNexusList, setAditionalGroupsNexusList }}
    >
      {children}
    </PagePresentatinContext.Provider>
  );
};
